import i18n from './../../../shared/i18n';

import BaseModel from "../../../core/components/input-widget/BaseModel";

export default class BankAccountForm extends BaseModel {
  customer_uuid = '';
  account_name = '';
  account_number = '';
  sort_code = '';
  bank_name = '';
  iban = '';
  swift = '';
  address = '';
  address_2 = '';
  address_3 = '';
  first_name = '';
  last_name = '';
  email = '';

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  rules = {
    email: 'email'
  };

  attributeLabels = {
    account_name: i18n.t('Account Name/Beneficiary'),
    account_number: i18n.t('Account Number'),
    sort_code: i18n.t('Sort Code'),
    bank_name: i18n.t('Bank Name'),
    iban: i18n.t('IBAN'),
    swift: i18n.t('Swift'),
    address: i18n.t('Address 1'),
    address_2: i18n.t('Address 2'),
    address_3: i18n.t('Address 3'),
    first_name: i18n.t('First Name'),
    last_name: i18n.t('Last Name'),
    email: i18n.t('Email'),
  };
}
